import apiClient from './apiClient';

/** Mirrors `backend/modules/postRace/postRace.types.ts`, the repo's habit for V2 payloads. */
export interface PostRaceState {
  enrollmentId: string;
  /** R47: `RACE` closes a specific plan, `PLAN_END` a reprise plan that reached its end. */
  kind: 'RACE' | 'PLAN_END';
  due: boolean;
  /** null on `PLAN_END`: a reprise plan has no race. */
  race: { name: string | null; date: string; discipline: 'triathlon' | 'duathlon' | 'running' | null } | null;
  /** `PLAN_END` only: the reprise plan's last day. */
  planEndsOn: string | null;
  result: {
    totalTimeSeconds: number;
    splits: { swim: number | null; t1: number | null; cycling: number | null; t2: number | null; running1: number | null; running2: number | null };
  } | null;
  preparation: { weeks: number; completedSessions: number; trainingSeconds: number };
  recovery: { endsOn: string; trainingResumesOn: string } | null;
  choice: 'NEW_RACE' | 'NO_OBJECTIVE' | null;
}

export const getPostRaceState = async (): Promise<PostRaceState | null> => (await apiClient.get('post-race')).data;

export const markPostRaceShown = async (): Promise<void> => {
  await apiClient.post('post-race/shown');
};

export const postponePostRace = async (): Promise<void> => {
  await apiClient.post('post-race/postpone');
};

/** Only « sans objectif daté » is a client-side choice; `NEW_RACE` is recorded by the enrollment. */
export const choosePostRaceNoObjective = async (): Promise<void> => {
  await apiClient.post('post-race/choice', { choice: 'NO_OBJECTIVE' });
};
